import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["href"]

import { ref, watch } from 'vue';

type DictionaryProps = {
  text: string;
  baseUrl?: string;
};

type LinkDictionaryField = {
  type: 'link';
  href: string;
  text: string;
  attributes: { target?: '_blank' };
};

type TextDictionaryField = {
  type: 'text';
  text: string;
};

type DictionaryField = LinkDictionaryField | TextDictionaryField ;


export default /*@__PURE__*/_defineComponent({
  __name: 'DictionaryItemWithLink',
  props: {
    text: {},
    baseUrl: { default: '' }
  },
  setup(__props: any) {

const props = __props;

const itemsToDisplay = ref<DictionaryField[]>([]);

// token param link format: {[The link text](https://thelink.com)[newtab]}
const parseLink = (token: string): LinkDictionaryField | undefined => {
  const startIndexOfLinkTextToken = token.indexOf('[');
  const endIndexOfLinkToken = token.indexOf(']', startIndexOfLinkTextToken);
  const startIndexOfLinkHrefToken = token.indexOf('(');
  const endIndexOfLinkHrefToken = token.indexOf(')', startIndexOfLinkHrefToken);

  if (startIndexOfLinkTextToken !== -1
  && endIndexOfLinkToken !== -1
  && startIndexOfLinkHrefToken !== -1
  && endIndexOfLinkHrefToken !== -1) {
    const text = token.substring(startIndexOfLinkTextToken + 1, endIndexOfLinkToken);
    const href = token.substring(startIndexOfLinkHrefToken + 1, endIndexOfLinkHrefToken);
    const restOfToken = token.substring(endIndexOfLinkHrefToken + 1, token.length - 1);
    const attributes: LinkDictionaryField['attributes'] = {};

    if (restOfToken) {
      if (restOfToken === '[newtab]') {
        attributes.target = '_blank';
      }
    }

    // @ in href indicates that the href should always be relative,
    // otherwise use props.baseUrl if it exists
    return {
      type: 'link',
      href: href.startsWith('%%') ? href.substring(2) : props.baseUrl + href,
      text,
      attributes,
    };
  }
  return undefined;
};

const parseToken = (token: string): DictionaryField | undefined => {
  const link = parseLink(token);
  if (link) return link;

  return undefined;
};

const initialiseDictionaryValue = (inputString: string) => {
  if (!inputString) return;

  const startIndexOfToken = inputString.indexOf('~');

  if (startIndexOfToken === -1) {
    // no start tokens - push the whole text string
    itemsToDisplay.value.push({ type: 'text', text: inputString });
    return;
  }

  const tokenEndIndex = inputString.indexOf('~', startIndexOfToken + 1);

  if (tokenEndIndex === -1) {
    // start token but no end token - push the whole text string
    itemsToDisplay.value.push({ type: 'text', text: inputString });
    return;
  }

  const textUpToToken = inputString.substring(0, startIndexOfToken);
  itemsToDisplay.value.push({ type: 'text', text: textUpToToken });
  const tokenContent = inputString.substring(startIndexOfToken, tokenEndIndex + 1);
  const item = parseToken(tokenContent);

  if (item) {
    itemsToDisplay.value.push(item);
  } else {
    itemsToDisplay.value.push({ type: 'text', text: tokenContent });
  }

  initialiseDictionaryValue(
    inputString.substring(tokenEndIndex + 1),
  ); // repeat until the end of the string
};

initialiseDictionaryValue(props.text);

watch(() => props.text, () => {
  itemsToDisplay.value = [];
  initialiseDictionaryValue(props.text);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemsToDisplay.value, (item, index) => {
    return (_openBlock(), _createElementBlock(_Fragment, null, [
      (item.type === 'link')
        ? (_openBlock(), _createElementBlock("a", _mergeProps({
            key: index,
            class: "link",
            href: item.href,
            ref_for: true
          }, item.attributes), _toDisplayString(item.text), 17, _hoisted_1))
        : (item.type === 'text')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(item.text), 1)
            ], 64))
          : _createCommentVNode("", true)
    ], 64))
  }), 256))
}
}

})